/**
 * Wrapper that triggers callback on keyup event. This function was created
 * To minimize the instantiation key events on the window object.
 * @param {object} keyEvent - Object of key events
 **/
export const keyup = function (keyEvent) {
	document.addEventListener('keyup', (event) => {
		if (event.keyCode == 27 && keyEvent && keyEvent.escape) {
			keyEvent.escape();
		}
	});
};
